import { fr as reactFr } from '@ews/react-translations';

const fr = {
    ...reactFr
};
export default fr;
